// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9674) return "static/chunks/9674-a45a37dfd198439f.js";
	if (chunkId === 5802) return "static/chunks/69b09407-afd0e2de6c011573.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"53":"4ef5a54132d2e902","1678":"84b11a6f8ab742d4","7584":"144f295445293c68","8974":"fca2681a6dd33787","9845":"97a8ddf403a2ee61"}[chunkId] + ".js";
};